// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1x7VS","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__OT-zo"};